import { render, staticRenderFns } from "./search-search.vue?vue&type=template&id=a33fdb66&scoped=true"
import script from "./search-search.vue?vue&type=script&lang=js"
export * from "./search-search.vue?vue&type=script&lang=js"
import style0 from "./search-search.vue?vue&type=style&index=0&id=a33fdb66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33fdb66",
  null
  
)

export default component.exports